import { type Report } from '@littlebird/sdk';
import { adaptReportToRoutineRun } from '@littlebird/ui-utils';
import { observer } from 'mobx-react-lite';

import { XStack } from '@/components/ui';
import { type ReportBody } from '@/features/routines/report-body';

import {
  RoutineReportCopyButton,
  RoutineReportSendToChat,
} from './routine-report-actions';
import { RoutineRunEntry } from './routine-run-entry';

type RoutineReportContentProps = {
  routineId: number;
  report: Report;
  reportBody: ReportBody;
  onCanvasReadyChange?: (isReady: boolean) => void;
};

export const RoutineReportContent = observer(
  ({
    routineId,
    report,
    reportBody,
    onCanvasReadyChange,
  }: RoutineReportContentProps) => {
    return (
      <RoutineRunEntry
        run={adaptReportToRoutineRun(report)}
        reportBody={reportBody}
        onCanvasReadyChange={onCanvasReadyChange}
        actions={
          <XStack className="gap-2">
            <RoutineReportCopyButton text={report.text.trim()} />
            <RoutineReportSendToChat routineId={routineId} />
          </XStack>
        }
      />
    );
  }
);
